import {
	BulkUpdateSingleSubscriptionUsersRequest,
	User,
	UserAction,
} from '@Types/user.types';

export const getUsersToAdd = (
	originalUsersInSubscription: string[],
	newUsers: string[],
) => newUsers.filter(user => !originalUsersInSubscription.includes(user));

export const getUsersToRemove = (
	originalUsersInSubscription: string[],
	newUsers: string[],
) => originalUsersInSubscription.filter(user => !newUsers.includes(user));

export default function getUsersToAddRemove(
	originalUsers: User[],
	newUsers: string[],
	subscriptionName: string,
): BulkUpdateSingleSubscriptionUsersRequest {
	const originalUsersInSubscription = originalUsers
		.filter(user => user.entitlements.includes(subscriptionName || ''))
		.map(user => user.id);

	const usersToAdd = getUsersToAdd(originalUsersInSubscription, newUsers);
	const usersToRemove = getUsersToRemove(
		originalUsersInSubscription,
		newUsers,
	);

	const addOperations = originalUsers
		.filter(user => usersToAdd.includes(user.id))
		.map(user => ({
			operation: 'PATCH',
			data: {
				id: user.id,
				entitlements: [...user.entitlements, subscriptionName],
			},
		}));

	const removeOperations = originalUsers
		.filter(user => usersToRemove.includes(user.id))
		.map(user => ({
			operation: 'PATCH',
			data: {
				id: user.id,
				entitlements: user.entitlements.filter(
					subscription => subscription !== subscriptionName,
				),
			},
		}));

	return {
		removeUserOperations: [...removeOperations] as UserAction[],
		addUserOperations: [...addOperations] as UserAction[],
	};
}
